import {Tooltip} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import React from 'react';
import {useTranslation} from 'react-i18next';

const SmartSearchButton = () => {
    const {t} = useTranslation();


    // deactivated for now
    if (true) return null

    return (
        <Tooltip title={t('Smart search')}>
            <IconButton
                size="small"
                onClick={() => alert('TODO Smart search is disabled for now')}
            >
                <SearchIcon/>
            </IconButton>
        </Tooltip>
    );
};

export default SmartSearchButton;